export default __webpack_public_path__ + "static/media/Vambraces of the Triumphant.dfc9cb52.jpg";